import { CludoDepartmentAndPsychiatricSearch } from 'ui/components';
import { useSiteContext } from 'application/contexts/SiteContext';

export const CludoDepartmentAndPsychiatricSearchFeature: React.FC<Content.CludoDepartmentAndPsychiatricSearch> = ({ content }) => {
    const siteContext = useSiteContext();
    const cludoEngineId = siteContext.cludoEngineId;

    return (<CludoDepartmentAndPsychiatricSearch {...content?.properties}cludoEngineId={cludoEngineId} />)
};
